const CHECKBOX = 'checkbox';
const LIST_ICON = 'list-icon';
const LIST_SIMPLE = 'list';

const TODAY = 'today';
const END_TODAY = 'end_today';
const THIS_MONTH = 'this_month';
const THIS_YEAR = 'this_year';
const LAST_YEAR = 'last_year';
const LAST_YEAR_END = 'last_year_end';

const FORMAT = 'YYYY-MM-DD';
const DAYJS_HUMAN_READABLE_FORMAT = 'DD MMM YYYY';
const ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

const PRIMARY_BLUE = '#027aff';
const LIGHT_GRAY = '#eee';
const TEXT_GRAY = '#999999';

const VARIANT_XL = 'XL';
const VARIANT_LARGE = 'Large';
const VARIANT_MEDIUM = 'Medium';
const VARIANT_SMALL = 'Small';
const VARIANT_SMALL_CREATE_CHALLENGE = 'Small-challenge';
const VARIANT_SMALL_HEADER = 'Small-Header';
const VARIANT_XS = 'XS';

const RED = 'red';
const BLUE = 'blue';
const GREEN = 'green';
const ORANGE = 'orange';
const YELLOW = 'yellow';
const PINK = 'pink';

const GLOBAL = 'FEATURED';
const CONNECTED = 'CONNECTED';
const LOCAL = 'LOCAL';

const METERS = 'M';
const KILOMETERS = 'KM';
const SECONDS = 'SEC';
const HOURS = 'HRS';
const HOUR = 'HR';
const DAYS = 'DAYS';
const MINUTES = 'MINS';

const CUSTOM = 'custom';
const CUSTOM_START = 'custom_start';
const CUSTOM_END = 'custom_end';

export const MEASUREMENT_UNITS = {
    METERS,
    KILOMETERS,
    SECONDS,
    HOURS,
    HOUR,
    DAYS,
    MINUTES,
};

export const CHALLENGE_TYPES = {
    GLOBAL,
    CONNECTED,
    LOCAL,
};

// These notification permissions constants are added according to
// values of
export const NOTIFICATION_PERMISSIONS = {
    [CHALLENGE_TYPES.GLOBAL]: 'pp_featured_challenge_send_notification',
    [CHALLENGE_TYPES.CONNECTED]: 'pp_connected_challenge_send_notification',
    [CHALLENGE_TYPES.LOCAL]: 'pp_local_challenge_send_notification',
};

export const RADIO_COLORS = [RED, BLUE, GREEN, ORANGE, YELLOW, PINK];

export const placeholderAvatar =
    'https://i.ebayimg.com/images/g/JV8AAOSwImRYHAqF/s-l300.jpg';

export const PICTURE_VARIANTS = {
    VARIANT_XL,
    VARIANT_LARGE,
    VARIANT_MEDIUM,
    VARIANT_SMALL,
    VARIANT_SMALL_HEADER,
    VARIANT_SMALL_CREATE_CHALLENGE,
    VARIANT_XS,
};

const CATEGORY = 'category';
const MATERIAL = 'material';
const OBJECT = 'object';
const BRAND = 'brand';

export const DROPDOWN_VARIANTS = {
    CHECKBOX,
    LIST_ICON,
    LIST_SIMPLE,
};

export const THEME = {
    PRIMARY_BLUE,
    LIGHT_GRAY,
    TEXT_GRAY,
};

export const PERIOD = {
    TODAY,
    END_TODAY,
    THIS_MONTH,
    THIS_YEAR,
    LAST_YEAR,
    LAST_YEAR_END,
    FORMAT,
    ISO_FORMAT,
    DAYJS_HUMAN_READABLE_FORMAT,
    CUSTOM,
    CUSTOM_START,
    CUSTOM_END,
};

export const TAXONOMY = {
    CATEGORY,
    MATERIAL,
    BRAND,
    OBJECT,
};

export const TAXONOMY_DROPDOWN = [
    {
        key: TAXONOMY.CATEGORY,
        label: 'Category',
        id: 2,
        icon: 'icon-profile-icon',
    },
    {
        key: TAXONOMY.OBJECT,
        label: 'Object',
        id: 3,
        icon: 'icon-power-icon',
    },
    {
        key: TAXONOMY.MATERIAL,
        label: 'Material',
        id: 4,
        icon: 'icon-settings-icon',
    },
    {
        key: TAXONOMY.BRAND,
        label: 'Brand',
        id: 4,
        icon: 'icon-power-icon',
    },
];

export const DROPDOWNDATA = [
    {
        key: PERIOD.THIS_MONTH,
        label: 'This Month',
        id: 1,
    },
    {
        key: PERIOD.TODAY,
        label: 'Today',
        id: 2,
    },
    {
        key: PERIOD.THIS_YEAR,
        label: 'This Year',
        id: 3,
    },
    {
        key: PERIOD.LAST_YEAR,
        label: 'Last Year',
        id: 3,
    },
];

export const LANDUSED_TYPE = [
    {
        key: null,
        label: 'All',
        id: -1,
    },
    {
        key: 'INLAND',
        label: 'In Land',
        id: 1,
    },
    {
        key: 'RIVER',
        label: 'River',
        id: 2,
    },
    {
        key: 'COASTAL',
        label: 'Coastal',
        id: 3,
    },
];

export const REPORT_TYPES = [
    {
        key: 'CUSTOM_REPORT',
        label: 'Main Report',
        id: 1,
    },
    {
        key: 'MS4_REPORT',
        label: 'Engage Overview Report',
        id: 2,
    },
];

export const SUBLAND_TYPE = [
    {
        key: null,
        label: 'All',
        id: -1,
    },
    {
        key: 'ROAD',
        label: 'Road (Rural)',
        id: 1,
    },
    {
        key: 'CITY_TOWN',
        label: 'City/Town (CENTER/RESIDENTIAL)',
        id: 2,
    },
    {
        key: 'INDUSTRIAL',
        label: 'Industrial',
        id: 3,
    },

    {
        key: 'PARK_URBAN',
        label: 'Park (Urban)',
        id: 4,
    },

    {
        key: 'PARKLAND',
        label: 'Parkland OR Agricultral',
        id: 5,
    },

    {
        key: 'OTHER',
        label: 'Other',
        id: 6,
    },
];

export const CHART_COLOURS = {
    BLUE: [
        '#027aff',
        '#1b87ff',
        '#3595ff',
        '#4ea2ff',
        '#67afff',
        '#81bdff',
        '#9acaff',
        '#b3d7ff',
        '#cce4ff',
        '#e6f2ff',
    ],
    ORANGE: [
        '#ffa403',
        '#ffad1c',
        '#ffb635',
        '#ffbf4f',
        '#ffc868',
        '#ffd281',
        '#ffdb9a',
        '#ffe4b3',
        '#ffedcd',
        '#fff6e6',
    ],
};

export const YEARS_DROPDOWN_DATA = [];

for (
    let year = new Date().getFullYear() - 5;
    year <= new Date().getFullYear();
    year++
) {
    YEARS_DROPDOWN_DATA.push({
        key: year,
        label: year,
        id: year,
    });
}

export default Object.freeze({
    DROPDOWN_VARIANTS,
    TAXONOMY_DROPDOWN,
    PICTURE_VARIANTS,
    CHART_COLOURS,
    THEME,
    PERIOD,
    TAXONOMY,
    RADIO_COLORS,
    DROPDOWNDATA,
    MEASUREMENT_UNITS,
    YEARS_DROPDOWN_DATA: YEARS_DROPDOWN_DATA.reverse(),
});

export const RESEARCH_FILTER_BY = [
    {
        key: 'name',
        label: 'Name',
        id: 'name',
    },
    {
        key: 'createdAt',
        label: 'Created At',
        id: 'createdAt',
    },
    {
        key: 'updatedAt',
        label: 'Last Updated',
        id: 'updatedAt',
    },
];

export const RESEARCH_SORT_BY = [
    {
        key: 'ASC',
        label: 'Ascending',
        id: 'ASC',
    },
    {
        key: 'DESC',
        label: 'Descending',
        id: 'DESC',
    },
];

export const CHALLENGE_TYPE_OBJECT = {
    LOCAL: {
        key: 'local',
        label: 'Local Challenge',
        id: 'local',
    },
    GLOBAL: {
        key: 'global',
        label: 'Featured Challenge',
        id: 'global',
    },
    CONNECTED: {
        key: 'connected',
        label: 'Connect to a Featured Challenge',
        id: 'connected',
    },
};

export const CHALLENGE_PRIVACY = {
    PUBLIC: {
        id: 'public',
        title: 'Public',
        description:
            'Anyone in the Litterati Community who is near your challenge can join.',
    },
    PRIVATE: {
        id: 'private',
        title: 'Private',
        description:
            "Private challenges are just for you and your family, friends, etc. It won't show up publicly & other people can only join by using the unique 'Challenge Share Code’.",
    },
};

export const CHALLENGE_THEME = {
    '#027aff': {
        shade1: '#00abff',
        shade2: '#027aff',
        value: '#027aff',
    },
    '#002382': {
        shade1: '#2f3dc6',
        shade2: '#002382',
        value: '#002382',
    },
    '#8c0000': {
        shade1: '#ba2121',
        shade2: '#8c0000',
        value: '#8c0000',
    },
};
